import { FC } from 'react'
import {
    Container,
    Heading,
    Text,
    VStack,
    useColorModeValue,
    Box,
    Button,
    Link,
    Icon,
    HStack,
} from '@chakra-ui/react'
import ReactTypingEffect from 'react-typing-effect'
import Fade from 'react-reveal/Fade'
import Socials from '../global/Socials'
import { Element, Link as ScrollLink } from 'react-scroll'
import DownArrow from './DownArrow'
import { FiArrowUpRight } from 'react-icons/fi'

const Intro: FC = () => {
    const muted = useColorModeValue('#5a657c', '#9199a9')

    return (
        <Element name='home'>
            <Container maxW={'6xl'} p={6.75} pt={['20vh', '28vh']} h={'100vh'}>
                <VStack spacing={3}>
                    <Heading
                        fontSize={['2.75rem', '3rem']}
                        fontWeight={500}
                        fontFamily={'source-code-pro, monospace'}
                        textAlign='center'
                    >
                        <ReactTypingEffect
                            text='Rosalinda (Rosie) Chen'
                            speed={85}
                            eraseDelay={1000000}
                            typingDelay={650}
                            cursor='_'
                        />
                    </Heading>
                    <Text fontSize={'1.25rem'} fontWeight={300} color={muted}>
                        📍 Berkeley, CA
                    </Text>
                    <Fade bottom cascade>
                        <Text
                            fontSize={'1.35rem'}
                            fontWeight={300}
                            color={muted}
                            textAlign='center'
                            letterSpacing={1.1}
                        >
                            Machine Learning Engineer · Software Engineer
                        </Text>
                        <Text
                            fontSize={'1.15rem'}
                            fontWeight={400}
                            maxW={'2xl'}
                            textAlign='center'
                            lineHeight={1.55}
                            pt={1}
                        >
                            I build production ML and data systems across
                            forecasting pipelines, RAG, and agent infrastructure
                            with measurable latency and accuracy gains.
                        </Text>
                        <Text
                            fontSize={'0.95rem'}
                            fontWeight={500}
                            textAlign='center'
                            pt={2}
                            letterSpacing={0.2}
                        >
                            83× GPU speedup · 4K+ robotics sims · 31% lower
                            agent latency
                        </Text>
                        <Text
                            fontSize={'0.9rem'}
                            fontWeight={300}
                            color={muted}
                            textAlign='center'
                            pt={1}
                        >
                            UC Berkeley M.S. Analytics '27 · UCLA B.S.
                            Statistics & Data Science + Applied Math
                        </Text>
                        <Text
                            fontSize={'0.95rem'}
                            fontWeight={500}
                            color={useColorModeValue('teal.700', 'teal.200')}
                            textAlign='center'
                            pt={1}
                        >
                            Open to ML / SWE internships and full-time roles
                            starting 2027
                        </Text>
                        <Box p={3}>
                            <Socials color={muted} />
                        </Box>
                    </Fade>
                    <HStack spacing={4} pt={1} flexWrap='wrap' justify='center'>
                        <Link
                            href={`${
                                typeof window !== 'undefined'
                                    ? window.location.origin
                                    : ''
                            }/SWE_Resume_Rosalinda_Chen.pdf`}
                            isExternal
                            target='_blank'
                            rel='noopener noreferrer'
                            _hover={{ textDecor: 'none' }}
                        >
                            <Button
                                variant={'solid'}
                                colorScheme={'cyan'}
                                aria-label={'View Resume'}
                                rightIcon={
                                    <Icon
                                        as={FiArrowUpRight}
                                        fontSize={18}
                                        mt={'3px'}
                                    />
                                }
                                rounded={'full'}
                                pb={1}
                            >
                                Resume
                            </Button>
                        </Link>
                        <ScrollLink
                            to='projects'
                            spy={true}
                            smooth={true}
                            duration={250}
                            offset={-80}
                        >
                            <Button
                                variant={'outline'}
                                colorScheme={'cyan'}
                                aria-label={'See selected work'}
                                rounded={'full'}
                                border={'2px'}
                                pb={1}
                                cursor={'pointer'}
                            >
                                See selected work
                            </Button>
                        </ScrollLink>
                    </HStack>
                </VStack>
                <Box mt={[8, '6vh']}>
                    <DownArrow />
                </Box>
            </Container>
        </Element>
    )
}

export default Intro
